// extracted by mini-css-extract-plugin
export default {"menuBlock":"uJ-z","title":"vJ-z","nav":"wJ-z","flexCell":"xJ-z","facetLink":"yJ-z"};